import styled from '@emotion/styled';
import { mediaQueries, palette, remCalc } from '../../css';

const StyledList = styled('ul')(() => ({
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    bottom: remCalc(4),
    width: '100%',
    margin: 0,
    zIndex: 2,
    lineHeight: 'normal',
    [mediaQueries.large]: {
        bottom: remCalc(12),
        lineHeight: 0,
    },
}));

const StyledItem = styled('li')(({ firstOrder }) => ({
    display: 'inline-block',
    padding: remCalc(0, 5),
    order: firstOrder ? 1 : 0,

    [mediaQueries.medium]: {
        padding: remCalc(0, 3),
    },
}));

const StyledButton = styled('button')(
    () => ({
        display: 'inline-block',
        width: remCalc(12),
        height: remCalc(12),
        borderRadius: '50%',
        transitionDuration: '250ms',
        transitionTimingFunction: 'ease-out',
        transitionProperty: 'transform',
        verticalAlign: 'middle',
        outline: 'none',
        color: 'rgba(255, 255, 255, 0)',
        backgroundColor: palette('white'),
        cursor: 'pointer',
        boxShadow: '0 0 0 1px rgba(0,0,0, 0.5)',
        [mediaQueries.large]: {
            width: remCalc(16),
            height: remCalc(16),
        },
        ':focus,:hover': {
            backgroundColor: palette('white'),
            transform: 'scale(1.2)',
        },
    }),
    ({ isActive, theme }) => {
        if (isActive) {
            return {
                backgroundColor: theme.slider.activeBulletColor,
                transform: 'scale(1.2)',
                ':focus,:hover': {
                    transform: 'scale(1.4)',
                },
            };
        }
        return {};
    },
);

const StyledPlay = styled('button')(() => ({
    marginTop: 0,
    marginLeft: remCalc(5),
    transitionDuration: '250ms',
    transitionTimingFunction: 'ease-out',
    transitionProperty: 'transform',
    verticalAlign: 'middle',
    zIndex: 2,
    cursor: 'pointer',
    transform: 'scale(1.2)',
    [mediaQueries.large]: {
        marginTop: remCalc(1),
        transform: 'scale(1.1)',
    },
    ':focus,:hover': {
        transform: 'scale(1.3)',
        '& svg': {
            fill: palette('white'),
        },
    },
}));

export { StyledButton, StyledItem, StyledList, StyledPlay };
